import { AbstractPersistentFilter } from './AbstractPersistentFilter.mjs'

export class SuffixUrlFilter extends AbstractPersistentFilter {
  static TYPE = 'suffix'
  constructor(opts = {}) {
    if (!opts.value) throw new Error('SuffixUrlFilters require a prefix value')
    super(SuffixUrlFilter.TYPE, opts)
    if (!opts.size && opts.secure)
      throw new Error('Secure SuffixUrlFilters require a prefix size')
    this.size = opts.size || null
  }
  matches(url) {
    if (!url) return false
    let size = this.size || this.value.length
    if (url.length < size) return false
    const suffixVal = url.slice(url.length - size)
    return this._normalize(suffixVal) === this.value
  }

  /** Assume exclusive **/
  explain(url) {
    console.log('Explaining SuffixUrlFilter for url: ', url, this.value)
    if (this.secure) {
      return 'Your settings prevent this URL from being displayed'
    }
    return `**${this.value} URLs are filtered out by your settings`
  }

  toJson() {
    return {
      ...super.toJson(),
      size: this.size,
    }
  }

  get simpleLabel() {
    return `**${this.value}`
  }

  get label() {
    return `URL ends with “${this.secure ? `[redacted]` : this.value}”`
  }
}
